// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HttpError_wrapper__zB-TZ","code":"HttpError_code__GO1Rm","title":"HttpError_title__11v1G","link":"HttpError_link__2Rcmy"};